<template>
  <div
    v-if="!!pagination.count"
    class="d-flex align-items-center gap-5 float-right"
  >
    <bp-button
      icon="fa fa-angle-left"
      size="md"
      variant="glyph"
      color="neutral"
      @click="changePage(-1)"
      :disabled="!pagination.previous"
    />
    <span class="text-neutral-500"> {{ value }} de {{ totalPages }} </span>
    <bp-button
      icon="fa fa-angle-right"
      size="md"
      variant="glyph"
      @click="changePage(1)"
      :disabled="!pagination.next"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number
    },
    pagination: {
      type: Object,
      required: true,
      default: () => ({
        next: null,
        previous: null,
        count: 0
      })
    },
    step: {
      type: Number,
      default: 20
    }
  },
  computed: {
    totalPages() {
      const total = Math.ceil(this.pagination.count / this.step);
      return isNaN(total) ? 1 : total;
    }
  },
  methods: {
    changePage(step) {
      this.$emit("input", this.value + step);
      this.$emit("change-page", (this.value + step - 1) * this.step);
    }
  }
};
</script>
